export default {
  /* eslint-disable no-dupe-keys */
  app_client: {
    prop: {
      device_brand: '手机品牌',
      device_model: '手机型号',
      device_os: '操作系统'
    },
    // Enums
    app_types: {
      miniprogram: '小程序',
      ios: 'iOS',
      android: '安卓'
    }
  }
}
